import { useQuery } from "@tanstack/react-query";
import { Users } from "lucide-react";
import api, { fmtINR, fmtDate } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/common";

export default function Customers() {
  const { data } = useQuery({ queryKey: ["agent-customers"], queryFn: async () => (await api.get("/agent/customers")).data });

  return (
    <div data-testid="customers-page">
      <PageHeader title="Customers" sub="People who ordered from you — private to your account." testid="customers-title" />
      {!data?.items?.length ? (
        <EmptyState title="No customers yet" sub="Customers appear here automatically when orders come in." />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-slate-100 bg-white shadow-sm">
          <table className="w-full text-left text-xs" data-testid="customers-table">
            <thead>
              <tr className="border-b border-slate-100 text-[10px] uppercase tracking-wider text-slate-400">
                <th className="px-4 py-3">Customer</th>
                <th className="px-4 py-3">Contact</th>
                <th className="px-4 py-3">Location</th>
                <th className="px-4 py-3">Orders</th>
                <th className="px-4 py-3">Total Spent</th>
                <th className="px-4 py-3">Channels</th>
                <th className="px-4 py-3">Last Order</th>
              </tr>
            </thead>
            <tbody>
              {data.items.map((c, i) => (
                <tr key={i} data-testid={`customer-row-${i}`} className="border-b border-slate-50 hover:bg-slate-50/60">
                  <td className="px-4 py-3">
                    <div className="flex items-center gap-2.5">
                      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-100 text-[#FF6B00]"><Users size={13} /></div>
                      <span className="font-medium text-[#0F2440]">{c.name || "Customer"}</span>
                    </div>
                  </td>
                  <td className="px-4 py-3 text-slate-500">{c.mobile}<br /><span className="text-[10px]">{c.email}</span></td>
                  <td className="px-4 py-3 text-slate-500">{c.city}{c.state ? `, ${c.state}` : ""}</td>
                  <td className="px-4 py-3 font-semibold text-[#0F2440]">{c.orders}</td>
                  <td className="px-4 py-3 font-semibold text-[#138808]">{fmtINR(c.spent)}</td>
                  <td className="px-4 py-3 capitalize text-slate-500">{c.channels.map((ch) => ch.replace(/_/g, " ")).join(", ")}</td>
                  <td className="px-4 py-3 text-slate-500">{fmtDate(c.last_order)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
